// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2Oxbd","header":"MessagesList_header__2rLUh","chat":"MessagesList_chat__12HTL"};